'use client';

import { Fragment, useState, useEffect } from 'react';
import { useTranslationDetector } from '@/hooks/useTranslationDetector';
import clsx from "clsx";

export default function SortingPanel({ onSortChange, initialSort = '0' }) {
  const t = useTranslationDetector('hotel');
  const [activeSort, setActiveSort] = useState(initialSort);

  // initialSort değiştiğinde activeSort'u güncelle
  useEffect(() => {
    setActiveSort(initialSort);
  }, [initialSort]);

  const sortOptions = [
    { id: '0', label: t('sortRecommended') },
    { id: '6', label: t('sortMostStars') },
    { id: '4', label: t('sortHighestRating') },
  ];

  const handleSortClick = (sortId) => {
    // Eğer zaten seçili olan seçeneğe tıklandıysa işlem yapma
    if (activeSort === sortId) {
      return;
    }
    setActiveSort(sortId);

    if (onSortChange) {
      onSortChange(sortId);
    }
  };

  return (
    <div className="bg-white rounded-[10px] px-4 hidden sm:block shadow-small">
      <div className="flex items-center">
        {sortOptions.map((option, index) => {
          const isActive = activeSort === option.id;
          const isLast = index === sortOptions.length - 1;

          return (
            <Fragment key={option.id}>
              <button
                onClick={() => handleSortClick(option.id)}
                className={clsx(
                  "relative flex items-center justify-center gap-2 py-1 transition-colors w-full h-[56px] cursor-pointer text-sm font-medium",
                  isActive
                    ? "text-primary"
                    : "text-foreground"
                )}
              >
                <span>{option.label}</span>

                {isActive && (
                  <div className="absolute bottom-[-1px] left-0 right-0 h-0.5 bg-primary rounded-t-[10px] rounded-b-0" />
                )}
              </button>
              {!isLast && (
                <div
                  aria-hidden="true"
                  className="mx-4 h-[56px] w-px self-center rounded-full bg-border-weak"
                />
              )}
            </Fragment>
          );
        })}
      </div>
    </div>
  );
}
